import ReactQueryParams from 'react-query-params';
import React from 'react';
import { withCookies } from 'react-cookie';
import Chart from './chart';
import { getData, getAdditionalData, getMRIData, getDailyOpinionData } from "./utils/utils"
import { timeParse } from "d3-time-format";
import { css } from '@emotion/core';
import { GridLoader } from 'react-spinners';
import DailyOpinionBox from './component/DailyOpinionBox'

import './App.css'
const parseDate = timeParse("%m/%d/%Y");

const override = "display: block;margin: 0px auto;border-color: red; width: 100px; height: 100px; inset: 0px; position: relative; display: block";

function dateToString(d){
  let s = "";
  s += d.getYear() + 1900;
  s += '-';
  s+= d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
  s += '-';
  s += d.getDate() < 10 ? '0' + d.getDate() : d.getDate();

  return s;
}
class App extends ReactQueryParams {
  defaultQueryParams = {
    symbol: 'QQQ',
    range: '6',
    charttype: "ohlc",
    indicator1: 'sma50_sma200',
    indicator2: 'tmti',
    opinion: 'asterisk,daily,short,long,timing',
    level: ''
  }

  marksData = [];

  constructor(){
    super();
    this.state = {
      duration: 120,
      stockType: "QQQ",
      charttype: "ohlc",
      level: '',
      indicator1: 'sma50_sma200',
      indicator2: 'tmti',
      range: '6',
      opinion: 'asterisk,daily,short,long,timing',
      asterisk: true,
      daily: true,
      short: true,
      long: true,
      timing: true,
      trend: true,
      trendline: false,
      fib: false,
      sr: true,
      dailyOpinionData: null,
      isOpinionBoxShow: false,
      crossHairs: null,
      opinionPos: null,
    }
    this.boxShowed = false;
    this.dragPrevPos = [];
    this.fetching = false;
    this.rdy = false;
    this.chartHeight = 700;
    window.lastPrice = 0;
  }
  refreshData = () => {
    getData(this.queryParams.symbol, this.queryParams.level).then(data => {
      getMRIData().then(mriData => {
        data.forEach(stock => {
          var stockDate = dateToString(stock.date);
          for(let i = 0;i < mriData.d.length;i ++)
            if(mriData.d[i][stockDate] !== undefined)
            {
              stock.mri = mriData.d[i][stockDate]
              break;
            }
        })

        if(window.lastPrice !== 0 && data[data.length - 1].close == 0)
        {
            data[data.length - 1].close = window.lastPrice;
            data[data.length - 1].label = 'lastprice';
        }
            
        this.setState({data: data })
      })

    })

    this.setState({stockType: this.queryParams.symbol, level: this.queryParams.level});
    
    getAdditionalData(this.queryParams.symbol, this.queryParams.level).then(data => {
      let {marks: marksData} = data;
      window.lastPrice = data.lastprice;
      
      if(this.state.data !== undefined && this.state.data !== null)
      {
        let {data} = this.state;
        if(data[data.length - 1].close == 0)
        {
            data[data.length - 1].close = window.lastPrice;
            data[data.length - 1].label = 'lastprice';
        }
            
        this.setState({data});
      }
        
      
      marksData.marks.map(mark => {
        mark.date = parseDate(mark.date);
      })

      this.marksData = marksData;
      this.filterMarks(this.state.asterisk, this.state.daily, this.state.short, this.state.long, this.state.timing);
    })
  } 
  refreshChart = (symbol = "QQQ", range = "6", indicator1, indicator2, chartType="ohlc", opinion="asterisk,daily,short,long,timing", level = '', rdy = false, chartHeight = 700) => {
    this.setState({data: null});
    this.rdy = rdy;
    this.chartHeight = chartHeight;
    getData(symbol, level).then(data => {
      getMRIData().then(mriData => {
        data.forEach(stock => {
          var stockDate = dateToString(stock.date);
          for(let i = 0;i < mriData.d.length;i ++)
            if(mriData.d[i][stockDate] !== undefined)
            {
              stock.mri = mriData.d[i][stockDate]
              break;
            }
        })
        if(window.lastPrice !== 0 && data[data.length - 1].close == 0)
        {
            data[data.length - 1].close = window.lastPrice;
            data[data.length - 1].label = 'lastprice';
        }
            
        this.setState({data })
      })
    })

    let asterisk = false, daily = false, short = false, long = false, timing = false;
    if(opinion.includes("asterisk") === true)
        asterisk = true;
    if(opinion.includes("daily") === true)
      daily = true;
    if(opinion.includes("short") === true)
      short = true;
    if(opinion.includes("long") === true)
      long = true;
    if(opinion.includes("timing") === true)
      timing = true;

    this.setState({indicator1, indicator2, charttype: chartType, stockType: symbol, daily, short, long, level, range: range, opinion: opinion});
    getAdditionalData(symbol, level).then(data => {
      let {marks: marksData} = data;
      
      window.lastPrice = data.lastprice;
      
      if(this.state.data !== undefined && this.state.data !== null)
      {
        let {data} = this.state;
        if(data[data.length - 1].close == 0)
        {
            data[data.length - 1].close = window.lastPrice;
            data[data.length - 1].label = 'lastprice';
        }
            
        this.setState({data});
      }

      marksData.marks.map(mark => {
        mark.date = parseDate(mark.date);
      })

      this.marksData = marksData;
      this.filterMarks(asterisk, daily, short, long, timing);
    })

    if(range === "Y")
      this.setState({duration: 260})
    if(range == 6)
      this.setState({duration: 120})
    if(range == 3)
      this.setState({duration: 60})
    if(range == 1)
      this.setState({duration: 20})
  }

    componentDidMount() {
        this.setState({charttype: this.queryParams.charttype, indicator1: this.queryParams.indicator1, indicator2: this.queryParams.indicator2})
        if(this.queryParams.range === "Y")
            this.setState({duration: 260})
        if(this.queryParams.range === "6")
            this.setState({duration: 120})
        if(this.queryParams.range === "3")
            this.setState({duration: 60})
        if(this.queryParams.range === "1")
            this.setState({duration: 20})
        const opinionString = this.queryParams.opinion;
        let asterisk = false, daily = false, short = false, long = false, timing = false;
        if(opinionString.includes("asterisk") === true)
            asterisk = true;
        if(opinionString.includes("daily") === true)
            daily = true;
        if(opinionString.includes("short") === true)
            short = true;
        if(opinionString.includes("long") === true)
            long = true;
        if(opinionString.includes("timing") === true)
            timing = true;

        const { cookies } = this.props;
        if(cookies.get('asterisk') !== undefined)
            asterisk = cookies.get('asterisk') === 'true';
        if(cookies.get('daily') !== undefined)
            daily = cookies.get('daily') === 'true';
        if(cookies.get('short') !== undefined)
            short = cookies.get('short') === 'true';
        if(cookies.get('long') !== undefined)
            long = cookies.get('long') === 'true';
        if(cookies.get('timing') !== undefined)
            timing = cookies.get('timing') === 'true';

        this.setState({asterisk, short, daily, long, timing, stockType:  this.queryParams.symbol, level: this.queryParams.level});
        this.refreshData();
    }

    filterMarks = (asterisk, daily, short, long, timing) => {
        let marks = [];
        if(asterisk == true)
            marks = marks.concat(this.marksData.marks.filter(mark => mark.opinion === "standard"));
        if(daily === true)
            marks = marks.concat(this.marksData.marks.filter(mark => mark.opinion === "daily"));
        if(short === true)
            marks = marks.concat(this.marksData.marks.filter(mark => mark.opinion === "short"));
        if(long === true)
            marks = marks.concat(this.marksData.marks.filter(mark => mark.opinion === "long"));
        if(timing === true)
            marks = marks.concat(this.marksData.marks.filter(mark => mark.opinion === "timing"));
        let additionalData = {...this.marksData};
        additionalData.marks = marks;

        
        this.setState({additionalData});
    }

    handleChangeDaily = () => {
        if(this.state.daily === false)
            this.filterMarks(this.state.asterisk, true, this.state.short, this.state.long, this.state.timing);
        else
            this.filterMarks(this.state.asterisk, false, this.state.short, this.state.long, this.state.timing);
        this.props.cookies.set('daily', !this.state.daily, { path: '/' });
        this.setState({daily: !this.state.daily});
    }

    handleChangeShortTerm = () => {
        if(this.state.short === false)
            this.filterMarks(this.state.asterisk, this.state.daily, true, this.state.long, this.state.timing);
        else
            this.filterMarks(this.state.asterisk, this.state.daily, false, this.state.long, this.state.timing);
        this.props.cookies.set('short', !this.state.short, { path: '/' });
        this.setState({short: !this.state.short});
    }

    handleChangeLongTerm = () => {
        if(this.state.long === false)
            this.filterMarks(this.state.asterisk, this.state.daily, this.state.short, true, this.state.timing);
        else
            this.filterMarks(this.state.asterisk, this.state.daily, this.state.short, false, this.state.timing);
        this.props.cookies.set('long', !this.state.long, { path: '/' });
        this.setState({long: !this.state.long});
    }

    handleChangeTiming = () => {
        if(this.state.timing === false)
            this.filterMarks(this.state.asterisk, this.state.daily, this.state.short, this.state.long, true);
        else
            this.filterMarks(this.state.asterisk, this.state.daily, this.state.short, this.state.long, false);
        this.props.cookies.set('timing', !this.state.timing, { path: '/' });
        this.setState({timing: !this.state.timing});
    }

    handleChangeAsterisk = () => {
        if(this.state.asterisk === false)
            this.filterMarks(true, this.state.daily, this.state.short, this.state.long, this.state.timing);
        else
            this.filterMarks(false, this.state.daily, this.state.short, this.state.long, this.state.timing);
        this.props.cookies.set('asterisk', !this.state.asterisk, { path: '/' });
        this.setState({asterisk: !this.state.asterisk});
    }

    handleChangeTrend = () => {
        this.setState({trend: !this.state.trend});
    }

    handleChangeTrendline = () => {
        var fib = this.state.fib;
        if(this.state.trendline == false)
            fib = false;
        this.setState({trendline: !this.state.trendline, fib});
    }

    handleChangeFib = () => {
        var trendline = this.state.trendline;
        if(this.state.fib == false)
        trendline = false;
        this.setState({fib: !this.state.fib, trendline});
    }

    handleChangeSR = () => {
        this.setState({sr: !this.state.sr});
    }

    handleDragStart = (e) => {
        
        e.dataTransfer.setData('text/plain', "ggg");
        this.dragPrevPos[0] = e.clientX;
        this.dragPrevPos[1] = e.clientY;

    }

    handleDrag = (e) => {
        
        if(e.clientX == this.dragPrevPos[0] && e.clientY == this.dragPrevPos[1])
            return;
        if(e.clientX == 0 || e.clientY == 0)
            return;

        let { transform } = this.state;

        transform[0] += e.clientX - this.dragPrevPos[0];
        transform[1] += e.clientY - this.dragPrevPos[1];

        this.dragPrevPos[0] = e.clientX;
        this.dragPrevPos[1] = e.clientY;

        this.setState({ transform });
    }

    getPosition = (moreProps) => {


        var mouseXY = moreProps.mouseXY;
        var width = moreProps.width;
        var finalPos = [];
        if(width - mouseXY[0] - 220 > mouseXY[0] - 210)
        {
            finalPos[0] = mouseXY[0] + 30;
        }else
            finalPos[0] = mouseXY[0] - 205;
        finalPos[0] = finalPos[0] < 0 ? 0 : finalPos[0];
        finalPos[0] = finalPos[0] + 200 > moreProps.width + 40 ? moreProps.width - 160 : finalPos[0];
        finalPos[1] = mouseXY[1];
        finalPos[1] = finalPos[1] + 430 - moreProps.height - 20 < 0 ? finalPos[1] : finalPos[1] + 430 - moreProps.height - 20;
        finalPos[1] = finalPos[1] < 200 ? 200 : finalPos[1];
        return finalPos;
    }

    handleSelectAsterisk = async (moreProps) => {
        
        var selected = moreProps.currentItem;
        if(this.fetching == true)
            return;
        if(selected == null)
            return;

        if(selected.date === undefined)
            return;
        var { opinionPos } = this.state;
        if(this.boxShowed == false)
        {
            this.boxShowed = true;
            opinionPos = this.getPosition(moreProps);
        }
        
        var currentDate = selected.date;
        let i = 0;
        for( i = 0;i < this.state.data.length;i ++)
        {
            var d = this.state.data[i].date;
            if(d.getFullYear() == currentDate.getFullYear() && d.getMonth() == currentDate.getMonth() && d.getDate() == currentDate.getDate())
                break;
        }
        var crossHairs = {xValue: i, yValue: selected.open};
        this.setState({opinionPos: opinionPos, isOpinionBoxShow: false, dailyOpinionData: null, crossHairs: crossHairs});    
        /*this.fetching = true;
        var data = await getDailyOpinionData(this.state.stockType, this.state.level, selected.date);
        //var data = await getDailyOpinionData(this.state.stockType, this.state.level, new Date('1/1/2019'));
        this.fetching = false;
        if(data.error !== undefined)
            return;
        this.setState({dailyOpinionData: data});*/

        this.setQueryParams({
          range: this.state.range,
          symbol: this.state.stockType,
          charttype: this.state.charttype,
          indicator1: this.state.indicator1,
          indicator2: this.state.indicator2,
          opinion: this.state.opinion,
          historyDate: currentDate
        });
        //window.location.reload(false);

    }

    handleClickNext = async (date) => {
        var currentDate = new Date(date);

        let i = 0;
        for( i = 0;i < this.state.data.length;i ++)
        {
            var d = this.state.data[i].date;
            if(d.getFullYear() == currentDate.getFullYear() && d.getMonth() == currentDate.getMonth() && d.getDate() == currentDate.getDate())
                break;
        }
        if(i == this.state.data.length - 1)
            return;
        var newDate = this.state.data[i + 1].date;
        var crossHairs = {xValue: i + 1, yValue: this.state.data[i + 1].open};
        this.setState({isOpinionBoxShow: true, dailyOpinionData: null, crossHairs: crossHairs});  
        this.fetching = true;
        var data = await getDailyOpinionData(this.state.stockType, this.state.level, newDate);
        this.fetching = false;
        if(data.error !== undefined)
            return;
        this.setState({dailyOpinionData: data});
    }



    handleClickPrev = async (date) => {

        var currentDate = new Date(date);

        let i = 0;
        for( i = 0;i < this.state.data.length;i ++)
        {
            var d = this.state.data[i].date;
            if(d.getFullYear() == currentDate.getFullYear() && d.getMonth() == currentDate.getMonth() && d.getDate() == currentDate.getDate())
                break;
        }
        if(i == 0)
            return;
        var newDate = this.state.data[i - 1].date;
        var crossHairs = {xValue: i - 1, yValue: this.state.data[i - 1].open};
        this.setState({isOpinionBoxShow: true, dailyOpinionData: null, crossHairs: crossHairs});  
        this.fetching = true;
        var data = await getDailyOpinionData(this.state.stockType, this.state.level, newDate);
        this.fetching = false;
        if(data.error !== undefined)
            return;
        this.setState({dailyOpinionData: data});

    }


    renderDailyOpinionBox = () => {
        if(this.state.isOpinionBoxShow === false) {
            return null;
        }
        return (
            <DailyOpinionBox data={ this.state.dailyOpinionData } handleClickClose={this.handleCloseOpinionBox} symbol={this.state.stockType} handleClickPrev={this.handleClickPrev} handleClickNext={this.handleClickNext} pos={this.state.opinionPos} handleDrag={this.handleDrag} handleDragStart={this.handleDragStart} ref={ref => {window.opinionBox = ref}}/>
        )
    }

    handleCloseOpinionBox = () => {
        this.boxShowed = false;
        this.setState({dailyOpinionData: null, isOpinionBoxShow: false, crossHairs: null});
    }

    render() {
        if (this.state.data == null || this.rdy == false) {
            return( 
                <div className="loader-container">
                    <GridLoader
                    css={override}
                    sizeUnit={"px"}
                    size={30}
                    color={'#123abc'}
                    loading={this.state.loading}
                    />
                </div>
            )
        }

        return (
            <div className="main-container" id="content">
        
            <div id="blank-div" style={{display: 'none'}}></div>
        {
            this.state.additionalData !== undefined &&
            [
            <div className="opinion-wrapper" key={1}>
            <span className="span-opinion">OUTLOOK:</span>
            <div className="opinion-container" >
                {/* <div className="input-container">
                <input
                    type="checkbox"
                    checked={this.state.asterisk}
                    onChange={this.handleChangeAsterisk} 
                    className="input-checkbox"
                    id="asterisk"
                    />
                <label htmlFor="asterisk" className="">Asterisk</label>
                
                </div> */}
                <div className="input-container">
                <input
                    type="checkbox"
                    checked={this.state.daily}
                    onChange={this.handleChangeDaily} 
                    className="input-checkbox"
                    id="daily"
                    />
                <label htmlFor="daily" className="">Immediate</label>
                
                </div>
                <div className="input-container">
                <input
                    type="checkbox"
                    checked={this.state.short}
                    onChange={this.handleChangeShortTerm} 
                    className="input-checkbox"
                    id="short"
                    />
                <label htmlFor="short" className="">Short-term</label>
                </div>
                <div className="input-container">
                <input
                    type="checkbox"
                    checked={this.state.long}
                    onChange={this.handleChangeLongTerm} 
                    className="input-checkbox"
                    id="long"
                    />
                <label htmlFor="long" className="">Long-term</label>
                </div>
                <div className="input-container timing">
                <input
                    type="checkbox"
                    checked={this.state.timing}
                    onChange={this.handleChangeTiming} 
                    className="input-checkbox"
                    id="timing"
                    />
                <label htmlFor="timing" className="">Timing</label>
                </div>
                <div className="input-container">
                <input
                    type="checkbox"
                    checked={this.state.trend}
                    onChange={this.handleChangeTrend} 
                    className="input-checkbox"
                    id="trend"
                    />
                <label htmlFor="trend" className="">Trend</label>
                </div>
            </div></div>,
            <div className="draw-container" key={2}>
                <span className="span-draw">DRAW:</span>
                <div className="input-container">
                    <input
                        type="checkbox"
                        checked={this.state.trendline}
                        onChange={this.handleChangeTrendline} 
                        className="input-checkbox"
                        id="trendline"
                        />
                    <label htmlFor="trendline" className="">TrendLine</label>
                </div>
                <div className="input-container">
                    <input
                        type="checkbox"
                        checked={this.state.fib}
                        onChange={this.handleChangeFib} 
                        className="input-checkbox"
                        id="fib"
                        />
                    <label htmlFor="fib" className="">Fib</label>
                </div>
                <div className="input-container">
                    <input
                        type="checkbox"
                        checked={this.state.sr}
                        onChange={this.handleChangeSR} 
                        className="input-checkbox"
                        id="fib"
                        />
                    <label htmlFor="fib" className="">Support/Resistance</label>
                </div>
            </div>
            ]}
            {
                this.renderDailyOpinionBox()
            }
            <div className="symbol-container">
                Symbol: <span style={{color: '#000000'}}>{ this.state.stockType }</span>
            </div>
            <Chart type="hybrid" data={this.state.data} duration={this.state.duration} additionalData={this.state.additionalData} stockType={this.state.stockType} chartType={this.state.charttype} indicator1={this.state.indicator1} indicator2={this.state.indicator2} enableTrendLine={this.state.trendline} enableFib={this.state.fib} trend={this.state.trend} sr={this.state.sr} handleSelectAsterisk={this.handleSelectAsterisk} crossHairs={this.state.crossHairs} chartHeight={this.chartHeight}/>
        </div>
        )
    }
}

export default withCookies(App);
